<div class="number-bullet-point">
    {{ number }}
</div>
